import { useRef, useState } from 'react';
import { ArrowUpTrayIcon, DocumentTextIcon, XMarkIcon } from '@heroicons/react/24/outline';

// Shared file dropzone matching the Eadin design system — used inside the
// payment dialog for optional attachments.
export const FileDropzone = ({ files, onChange, compact = false, testId }) => {
    const inputRef = useRef(null);
    const [dragOver, setDragOver] = useState(false);

    const addFiles = (list) => {
        if (!list) return;
        onChange([...files, ...Array.from(list)]);
    };

    return (
        <div className="space-y-1.5" data-testid={testId}>
            <div
                onClick={() => inputRef.current?.click()}
                onDragOver={(e) => { e.preventDefault(); setDragOver(true); }}
                onDragLeave={() => setDragOver(false)}
                onDrop={(e) => { e.preventDefault(); setDragOver(false); addFiles(e.dataTransfer.files); }}
                className={`flex items-center justify-center gap-2 rounded-lg border-2 border-dashed cursor-pointer transition-colors ${
                    compact ? 'py-3' : 'py-6 flex-col'
                } ${dragOver ? 'border-primary bg-gray-100' : 'border-gray-200 hover:bg-gray-50'}`}
            >
                <ArrowUpTrayIcon className="h-4 w-4 text-gray-400" />
                <span className="text-xs text-gray-500">Drop files or click to browse</span>
                <input
                    ref={inputRef}
                    type="file"
                    multiple
                    className="hidden"
                    onChange={(e) => { addFiles(e.target.files); e.target.value = ''; }}
                />
            </div>
            {files.length > 0 && (
                <div className="space-y-1 max-h-28 overflow-y-auto">
                    {files.map((file, index) => (
                        <div key={`${file.name}_${index}`} className="flex items-center gap-2 text-xs py-1 px-2 rounded bg-gray-100">
                            <DocumentTextIcon className="h-3.5 w-3.5 text-gray-400 shrink-0" />
                            <span className="truncate">{file.name}</span>
                            <span className="ml-auto text-gray-500 whitespace-nowrap">{(file.size / 1024).toFixed(0)} KB</span>
                            <button
                                type="button"
                                onClick={(e) => { e.stopPropagation(); onChange(files.filter((_, i) => i !== index)); }}
                                className="p-0.5 rounded hover:bg-gray-200"
                                aria-label="Remove file"
                            >
                                <XMarkIcon className="h-3 w-3" />
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};
